export const ENGLISH_LANG_CODE = 'en-us'
export const SPANISH_LANG_CODE = 'es-us'
export const SPANISH_LANG_CODE_SHORT = 'es'
